import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { cloneDeep } from 'lodash-es';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const PerformanceDashboard = lazy(
  () => import('../../../../main/agency/profile/performance-sections/performance-dashboard/PerformanceDashboard')
);

const QaReportPage = lazy(
  () => import('../../../../main/agency/profile/performance-sections/qa-report-page/QaReportPage')
);

const AgencyAvailabilitySections = lazy(
  () => import('../../../../main/agency/profile/availability-sections/AgencyAvailabilitySections')
);

const AgencyDetailsSections = lazy(
  () => import('../../../../main/agency/profile/details-sections/AgencyDetailsSections')
);

const AgencyDisciplinesSections = lazy(
  () => import('../../../../main/agency/profile/qualifications-sections/AgencyDisciplinesSections')
);

const AgencyPerformanceSections = lazy(
  () => import('../../../../main/agency/profile/performance-sections/PerformanceSections')
);

const AgencyBankAccountSection = lazy(
  () => import('../../../../main/agency/profile/bank-account-section/AgencyBankAccountSection')
);

const StaffRoster = lazy(() => import('../../../../main/agency/profile/users-sections/staff-roster/StaffRoster'));

const AddMember = lazy(
  () => import('../../../../main/agency/profile/users-sections/staff-roster/sections/add-member/AddMember')
);
const EditMember = lazy(
  () => import('../../../../main/agency/profile/users-sections/staff-roster/sections/edit-member/EditMember')
);

export const agencyPerformanceRoutes: RouteObject[] = [
  {
    path: '',
    element: <AgencyPerformanceSections />,
    children: [
      {
        path: '',
        element: <Navigate replace to="dashboard" />,
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PerformanceDashboard />
          </Suspense>
        ),
      },
      {
        path: 'qa-report',
        element: (
          <Suspense fallback={<DataLoader />}>
            <QaReportPage />
          </Suspense>
        ),
      },
      // {
      //   path: 'ctp_records',
      //   element: (
      //     <Suspense fallback={<DataLoader />}>
      //       <>CTP Records tab</>
      //     </Suspense>
      //   ),
      // },
      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
];

export const getAgencyPerformanceRoutes = (excludes: string[]): RouteObject[] => {
  const routes = cloneDeep(agencyPerformanceRoutes);
  const result =
    routes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  routes[0].children = result;
  return routes;
};
